(function(angular) {

    'use strict';

    angular.module('app.purchase')
        .controller('app.purchase.waStateModalController', ['$uibModalInstance', waStateModalController]);

    function waStateModalController($uibModalInstance) {
        var vm = this;
        vm.siteContent = siteContent;
        vm.done = done;
        
        //Close the modal 
        function done() {
            $uibModalInstance.close();
        }
    }
})(angular);